import Vue from "vue";
import Vuetify from "vuetify/lib";
import de from "vuetify/es5/locale/de";
import colors from "vuetify/lib/util/colors";
import minifyTheme from "minify-css-string";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { de },
    current: "de"
  },
  theme: {
    options: { minifyTheme },
    light: true,
    themes: {
      light: {
        primary: colors.green.darken4
      }
    },
    background: colors.grey.lighten1
  },
  icons: {
    iconfont: "mdiSvg"
  }
});
